export default "__VITE_ASSET__BX$yys6l__"